var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitsIconFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a8a29e",
    d: "M 280.953125 0 L 93.75 0 C 42.261719 0 0 42.261719 0 94.046875 L 0 281.25 C 0 332.738281 42.261719 375 93.75 375 L 280.953125 375 C 332.738281 375 375 332.738281 375 280.953125 L 375 94.046875 C 375 42.261719 332.738281 0 280.953125 0 Z M 237.796875 187.5 L 202.382812 187.5 L 202.382812 303.570312 L 157.738281 303.570312 L 157.738281 187.5 L 133.929688 187.5 L 133.929688 139.882812 L 154.761719 139.882812 L 154.761719 119.644531 C 154.761719 100.59375 164.285156 70.535156 204.464844 70.535156 L 241.070312 70.535156 L 241.070312 110.117188 L 215.179688 110.117188 C 211.011719 110.117188 205.355469 112.796875 205.355469 122.023438 L 205.355469 139.882812 L 241.964844 139.882812 Z M 237.796875 187.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitsIconFb);
export default __webpack_public_path__ + "static/media/kits_icon_fb.3a8a297eb9eacce575e0b5cd0aec7691.svg";
export { ForwardRef as ReactComponent };